import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=45062040&"
import script from "./Auth.vue?vue&type=script&lang=js&"
export * from "./Auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45062040')) {
      api.createRecord('45062040', component.options)
    } else {
      api.reload('45062040', component.options)
    }
    module.hot.accept("./Auth.vue?vue&type=template&id=45062040&", function () {
      api.rerender('45062040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Auth/Auth.vue"
export default component.exports